import { Button, ButtonStyles, FloatingSnackbar } from '@silverfort/sf-components';
import useMutateInsightEntityState from '../api/mutations/useMutateInsightEntityState';
import { INSIGHT_STATUS_DESCRIPTIONS, INSIGHT_STATUSES } from '@silverfort-nodelibs/common/utils/consts';
import { FC, useState } from 'react';
import { useIspmContext } from '../IspmContext';
import { InsightEntity } from '../api/types/Insights';
import { ResolutionFeedbackPopup } from './ResolutionFeedbackPopup/ResolutionFeedbackPopup';

interface Props {
    isOpen: boolean;
    onClose: () => void;
    selectedEntities: string[];
    allEntities: InsightEntity[];
    onSuccess?: (newStatusDescription: string) => void;
    onError?: (newStatusDescription: string, error?: any) => void;
}

const EntitiesDecisionSnackbar: FC<Props> = ({
    isOpen,
    onClose,
    selectedEntities,
    allEntities,
    onSuccess,
    onError
}) => {
    const [isResolutionPopupOpen, setIsResolutionPopupOpen] = useState(false);
    const { selectedInsight } = useIspmContext();
    const { mutate } = useMutateInsightEntityState();

    const handleStatusChange = (newStatus: string, newStatusDescription: string) => {
        void mutate({
            selectedEntities: allEntities?.filter((row) => selectedEntities.includes(row.guid)),
            insightName: selectedInsight!,
            newStatus,
            newStatusDescription,
            onSuccess: () => onSuccess?.(newStatusDescription),
            onError: (error) => onError?.(newStatusDescription, error)
        });
        onClose();
    };

    const onResolutionPopupClose = () => {
        setIsResolutionPopupOpen(false);
    };

    return (
        <>
            <FloatingSnackbar
                sx={{ position: 'absolute', minWidth: '567px' }}
                onClose={onClose}
                selections={selectedEntities.length}
                open={isOpen}>
                <>
                    <Button
                        onClick={() => handleStatusChange(INSIGHT_STATUSES.ACTIVE, INSIGHT_STATUS_DESCRIPTIONS.OPEN)}
                        buttonStyle={ButtonStyles.Ghost}
                        text="Open"
                    />
                    <Button
                        onClick={() =>
                            handleStatusChange(INSIGHT_STATUSES.ACTIVE, INSIGHT_STATUS_DESCRIPTIONS.IN_PROGRESS)
                        }
                        className="!min-w-max"
                        buttonStyle={ButtonStyles.Ghost}
                        text={INSIGHT_STATUS_DESCRIPTIONS.IN_PROGRESS}
                    />
                    <Button
                        onClick={() =>
                            handleStatusChange(INSIGHT_STATUSES.ACTIVE, INSIGHT_STATUS_DESCRIPTIONS.ACCEPTED)
                        }
                        buttonStyle={ButtonStyles.Ghost}
                        text="Accepted Risk"
                    />
                    <Button
                        onClick={() => setIsResolutionPopupOpen(true)}
                        className="!min-w-max"
                        buttonStyle={ButtonStyles.Ghost}
                        text={INSIGHT_STATUS_DESCRIPTIONS.RESOLVED}
                    />
                </>
            </FloatingSnackbar>
            <ResolutionFeedbackPopup
                isOpen={isResolutionPopupOpen}
                handleStatusChange={handleStatusChange}
                onClose={onResolutionPopupClose}
            />
        </>
    );
};

export default EntitiesDecisionSnackbar;
